import React from "react";
import PropTypes from "prop-types";
import { Tag } from "@td/ui";
import { translate } from "@td/shared_utils";

const COLORS = {
  NOTSTARTED: "#00498A",
  INPROGRESS: "#2C632F",
  CANCELLED: "#666F7F",
  COMPLETED: "#172636",
};

const Status = React.memo(({ value, style }) => (
  <Tag
    color={COLORS[value]}
    label={translate(null, "care_team_tasks.statuses", value)}
    style={{
      minWidth: 92,
      padding: "0.25rem 0",
      ...style,
    }}
  />
));

Status.propTypes = {
  value: PropTypes.string.isRequired,
  style: PropTypes.object,
};

export default Status;
